import { gql } from '../../../__generated__/graphql/catalog'

export const GET_FAVORITES_QUERY = gql(`
  query GetFavorites ($visitorId: ID) {
    customerProfile (visitorId: $visitorId)  {
      id
      favorites(first: 100, visitorId: $visitorId) {
        edges {
          node {
            ...CustomerProfileFavoritesNode
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`)

export const CUSTOMER_PROFILE_FAVORITES_NODE_FRAGMENT = gql(`
    fragment CustomerProfileFavoritesNode on CustomerProfileFavorite {
      __typename
      id
      productGroupHandle
      color
      fit
      size
    }
`)
